import React, { useState,  useEffect, useCallback } from 'react';
import { Button, Form, Input } from "semantic-ui-react";
import {
  Container,
  Title
} from './styles';

import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import CertificateEditor from '../../../../../components/Admin/Certificado/CertificateEditor';
import { producaov2 as api } from '../../../../../services/apis';
import swal from 'sweetalert';
import * as yup from 'yup';

import { isAuthAdmin } from "../../../../../services/auth";

const EditarCertificado = (props) => {
  const [certificado, setCertificado] = useState(null);

  useEffect(() => {
    const id = props.match.params.id;
    loadAuth();
    api
      .get(`layout-certificados/${id}`)
      .then(async res => {
        let array = { local: 'ead/certificado', texto: `listou o modelo de id=${id}` };
        await api.post('system_logs',
          { acao: JSON.stringify(array) }
        );
        const certificado = res.data;

        if (certificado.fundo[0] === '/') {
          certificado.fundo = `https://www.voitto.com.br/api${certificado.fundo}`;
        }

        setCertificado(certificado);
      })
      .catch(err => {
        console.error(err);
        props.history.push('/admin/ead/certificadosdev');
      })
  }, []);

  const loadAuth = async () => {
    if (!isAuthAdmin('ead\\/certificados')) {
      localStorage.setItem("redirect", `/admin/`)
      window.location.href = "/login";
      return null;
    }
  }

  const handleCertificado = useCallback(e => {
    const { value, name } = e.target;
    const newCertificado = { ...certificado };
    newCertificado[name] = value;
    setCertificado(newCertificado);
  }, [certificado]);

  const handleSubmit = useCallback(e => {
    e.preventDefault();


    const image = certificado.fundo;
    certificado.fundo = '';

    const certificadoSchema = yup.object().shape({
      title: yup
        .string("Por gentileza, insira um título válido")
        .required("Por gentileza, insira um título"),
      qrcode_color: yup
        .string("Por gentileza, insira uma cor válida")
        .required("Por gentileza, insira uma cor válida"),
      fonte: yup
        .string("Por gentileza, insira uma fonte válida")
        .required("Por gentileza, insira uma fonte"),
      qrcode_dim: yup
        .string("Por gentileza, insira um QR Code DIM válido")
        .required("Por gentileza, insira um QR Code DIM"),
      qrcode_loc: yup
        .string("Por gentileza, insira um QRCode válido")
        .required("Por gentileza, insira um QRCode"),
      nome_loc: yup
        .string("Por gentileza, insira um nome válido")
        .required("Por gentileza, insira um nome"),
      iconcurso_loc: yup
        .string("Por gentileza, insira um icon de curso válido")
        .required("Por gentileza, insira um icon de curso"),
      assinaturavoitto_loc: yup
        .string("Por gentileza, insira um assinatura da Voitto válida")
        .required("Por gentileza, insira um assinatura da Voitto"),
      assinaturaconsultor_loc: yup
        .string("Por gentileza, insira um assinatura do consultor válida")
        .required("Por gentileza, insira um assinatura do consultor"),
      descricao_loc: yup
        .string("Por gentileza, insira um descrição válida")
        .required("Por gentileza, insira um descrição"),
      fundo_loc: yup
        .string("Por gentileza, insira um título válido")
        .required("Por gentileza, insira um título"),
      fundo: yup.string(),
      cert_w: yup.string().required("Por gentileza, insira um título"),
      cert_h: yup.string().required("Por gentileza, insira um título"),
    });

    certificadoSchema.validate(certificado, { abortEarly: true })
      .then(async () => {
        try {
          const payload = { ...certificado };

          if (typeof image !== 'string') {
            const data = new FormData();
            data.append("file", image);
            data.append("nome", `${new Date().toISOString()}modelo_certificado`);
            data.append("path", "imagens-voitto");
            const res = await api.post('upload', data);
            payload.fundo = res.data.url;
          } else {
            payload.fundo = image;
          }

          const id = props.match.params.id;

          api
            .put(`layout-certificados/${id}`, payload)
            .then(async res => {
              let array = { local: 'ead/certificadoModelo', texto: `editou o modelo de certificado de id=${id}` };
              await api.post('system_logs',
                { acao: JSON.stringify(array) }
              );
              swal('Sucesso !', 'Modelo de certificados foi criado', 'success');
              setCertificado(payload);
            })
            .catch(err => {
              console.error(err);
              swal('Ops !', 'Houve um erro na criação de certificado', 'error');
            });
        } catch (err) {
          console.error(err);
          swal('Ops !', 'Houve um erro ao salvar a imagem de seu certificado', 'error');
        }
      })
      .catch(err => {
        swal('Ops !', `${err}`.replace('ValidationError:', ''), 'error')
      })
  }, [certificado]);

  if (!certificado) {
    return null;
  }

  return (
    <>
      <AdminMenu />
      <Container>
        <Title>Criar modelo de certificado</Title>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Titulo do modelo</label>
              <Input
                placeholder="Titulo do modelo"
                name="title"
                value={certificado.title}
                onChange={handleCertificado}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <label>Cor QRCODE</label>
              <input
                type='color'
                name="qrcode_color"
                value={certificado.qrcode_color}
                onChange={handleCertificado}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <label>Fonte</label>
            <input
              name="fonte"
              value={certificado.fonte}
              onChange={handleCertificado}
            />
          </Form.Field>
          <Form.Field>
            <label>Largura (cm)</label>
            <input
              type="number"
              name="cert_w"
              value={certificado.cert_w}
              onChange={handleCertificado}
            />
          </Form.Field>
          <Form.Field>
            <label>Altura (cm)</label>
            <input
              type="number"
              name="cert_h"
              value={certificado.cert_h}
              onChange={handleCertificado}
            />
          </Form.Field>


          <CertificateEditor
            certificado={certificado}
            setCertificado={setCertificado}
            display
          />

          <Form.Group>
            <Form.Field>
              <Button onClick={handleSubmit}>
                Salvar
              </Button>
            </Form.Field>
            <Link to="/admin/ead/certificados">
              <Button color="secondary">Cancelar</Button>
            </Link>
          </Form.Group>
        </Form>
      </Container>
    </>
  )
}

export default withRouter(EditarCertificado);